import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Trans } from 'react-i18next'
import { Link } from 'react-router-dom'

export class AdministratorTable extends Component {
  static defaultProps = {
    administrators: [],
  }

  static propTypes = {
    administrators: PropTypes.array,
  }

  render() {
    const { administrators } = this.props
    return (
      <table className="md-table">
        <thead>
          <tr>
            <th>
              <Trans>Nombre</Trans>
            </th>
            <th className="col-large">
              <Trans>Email</Trans>
            </th>
            <th>
              <Trans>Teléfono</Trans>
            </th>
            <th>
              <Trans>Avatar</Trans>
            </th>
            <th>
              <Trans>Tipo</Trans>
            </th>
            <th>
              <Trans>Compañía</Trans>
            </th>
            <th>
              <Trans>Proveedor</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {administrators.map((admin) => (
            <tr key={admin.id}>
              <td className="col-center">
                <Link to={`administrator/${admin.id}`}>{admin.name} </Link>
              </td>
              <td className="col-center">{admin.email}</td>
              <td className="col-center">{admin.phone}</td>
              <td className="col-center">
                <img
                  src={admin.avatar}
                  style={{ height: 50, width: 50, objectFit: 'cover' }}
                  alt={`altImage${admin.id}`}
                />
              </td>
              <td className="col-center">{admin.type}</td>
              <td className="col-center">{admin.company && admin.company.name}</td>
              <td className="col-center">{admin.provider && admin.provider.name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}
